<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-app-bar dark color="primary">
            <v-toolbar-title>{{ $t("auth.forgot.forgot_t") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                name="email"
                v-model="email"
                prepend-icon="person"
                :label="$t('auth.email')"
                class="required-field"
                v-validate="'required'"
                :error-messages="errors.collect('email')"
                type="text"
                autocomplete="new-password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>

            <router-link :to="'/auth/' + locale + '/login'" class="mr-2">
              <action-button type="default" :text="this.$t('global.back')" :icon_only_xs="false" />
            </router-link>

            <action-button @click="send" type="default" :text="this.$t('auth.forgot.send_request')" :icon_only_xs="false" />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import swal from "sweetalert"

export default {
  name: "Forgot",

  props: ["locale"],

  data() {
    return {
      email: ""
    }
  },

  created() {
    let vm = this
    let user = localStorage.getItem("__crrntUser")

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    if (user) {
      vm.$router.push(this.BACKEND_URL + "/dashboard")
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  methods: {
    send() {
      let vm = this

      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            axios
              .post(this.API_URL + "auth/forgotpassword/request", {
                email: vm.email,
                site: process.env.VUE_APP_DOMAIN,
                subdomain: vm.SUBDOMAIN
              })
              .then((res) => {
                let status = res.data.status
                let logo = res.data.icon

                if (status == "sent") {
                  vm.$awn.success(vm.$t("auth.forgot.forgot_success_m") + vm.email)
                  vm.$router.push("/auth/" + this.locale + "/login")
                } else if (status == "unregistered") {
                  vm.$awn.alert(vm.email + vm.$t("auth.forgot.unregistered"))
                  vm.$router.push("/auth/" + this.locale + "/login")
                } else {
                  vm.$awn.alert(vm.email + vm.$t("auth.forgot.forgot_error_m"))
                  vm.email = ""
                }
              })
              .catch((err) => console.log(err))
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    }
  }
}
</script>
